var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 38,
    viewBox: "0 0 21 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3067_191456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(0.83205 0.5547 0 1 0.25 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3067_191456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73993 25.0271V22.3271L2.62128 19.5814C2.33006 19.3872 2.11165 19.0875 1.96604 18.682C1.82043 18.2766 1.8239 17.9748 1.97644 17.7765L4.43099 14.7878C4.16751 14.6122 3.97336 14.3494 3.84856 13.9996C3.72375 13.6497 3.73068 13.3876 3.86936 13.2134L7.59278 8.52071C7.74533 8.33907 7.96027 8.3407 8.23762 8.5256C8.51497 8.7105 8.72992 8.99547 8.88246 9.38049L10.2345 12.9069L11.5866 11.1833C11.7392 11.0016 11.9541 11.0033 12.2315 11.1882C12.5088 11.3731 12.7238 11.658 12.8763 12.0431L16.5997 21.7003C16.7384 22.0595 16.7453 22.3307 16.6205 22.5142C16.4957 22.6977 16.3016 22.7016 16.0381 22.5259L18.4926 28.7873C18.6452 29.189 18.6487 29.4955 18.503 29.7067C18.3574 29.918 18.139 29.9265 17.8478 29.7324L13.7292 26.9866V29.6866C13.7292 29.9366 13.6564 30.1006 13.5107 30.1785C13.3651 30.2564 13.1883 30.2261 12.9803 30.0874L11.4826 29.0889C11.2746 28.9503 11.0978 28.7449 10.9522 28.4728C10.8066 28.2007 10.7338 27.9397 10.7338 27.6897V24.9897L9.73531 24.3241V27.0241C9.73531 27.2741 9.66251 27.438 9.5169 27.516C9.37129 27.5939 9.19448 27.5635 8.98647 27.4248L7.48878 26.4264C7.28076 26.2877 7.10395 26.0823 6.95834 25.8103C6.81274 25.5382 6.73993 25.2771 6.73993 25.0271ZM14.27 25.5472L16.4749 27.0171L13.3131 18.9093L14.5196 19.7136L12.2315 13.7882L11.1082 15.1893L12.6059 19.0378C12.7446 19.3969 12.7515 19.6682 12.6267 19.8516C12.5019 20.0351 12.3077 20.039 12.0443 19.8634L14.27 25.5472ZM3.97336 18.6828L12.5019 24.3684L9.31929 16.2467L10.5258 17.051L8.23762 11.1256L5.94948 14.0002L7.15596 14.8045L3.97336 18.6828ZM3.97336 18.6828L6.88554 20.6242L5.63746 19.7922L10.3594 22.9401L9.11127 22.108L12.5019 24.3684L3.97336 18.6828ZM14.27 25.5472L11.857 23.9385L13.7292 25.1866L11.1706 23.4809L14.8524 25.9355L14.27 25.5472Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegna);
export default __webpack_public_path__ + "static/media/legna.799688c9dcb9b2d322d4061e7209acda.svg";
export { ForwardRef as ReactComponent };